import React from 'react';
import {Button, Grid, Image} from 'semantic-ui-react'
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { AppBar, Avatar, Badge, Box, IconButton, Toolbar, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Bell as BellIcon } from '../../icons/Bell';
import { UserCircle as UserCircleIcon } from '../../icons/UserCircle';
import { Users as UsersIcon } from '../../icons/Users';
import { GridOnRounded } from '@mui/icons-material';
import useGlobalConfig from '../../hooks/globalConfig';
const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3]
}));

export const DashboardNavbar = (props) => {
  const { onSidebarOpen, ...other } = props;
 const {img5} = useGlobalConfig()


  return (
    <>
      <Grid className="navbar-dash">
        <Grid.Column>
        <Grid.Row className="navbarow-dash">           

        <Tooltip title="Contacts">
                <IconButton sx={{ ml: 1 }}>
                  <UsersIcon fontSize="small" />
                </IconButton>
          </Tooltip>
                   
          <Tooltip title="Notifications">
          <IconButton sx={{ ml: 1 }}>
              <Badge
                badgeContent={4}
                color="primary"
                variant="dot"
              >
                <BellIcon fontSize="small" />
              </Badge>
          </IconButton>
          </Tooltip>
          <Avatar
            sx={{
              height: 40,
              width: 40,
              ml: 1
            }}
            src={img5}
          >
            <UserCircleIcon fontSize="small" />
          </Avatar>

        </Grid.Row>
        </Grid.Column>

     </Grid>
    </>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func
};
